// removed by extract-text-webpack-plugin
module.exports = {"verificationForm":"fYhGlMLItLdekoMa8Y5RO","label":"_1GagcZIzaeGaAOA1XG6d8y","title":"AjcakP-1xPIqJTY3MhPaD","tooltipButton":"_3MY3bDWBob_w2D8vgFCJox","phoneSection":"_1js2nKUZq5atw1Baory9Rt","submitButton":"x7J1Wznu0XwgsArTargYv","codeSection":"_3ptgZ7jFYSz1aOz6889N-0","inputWrapper":"_1fzu8Tjxaa9bAItsE50iRQ","invalidMessage":"_2z0Onemy6n0Y6jVlWiZdl0","sendAgain":"_1rMJLoHn4a_Gj2ubViUEKp","notReceiveMessage":"yhQIR0scXzwOBsLflVmm3","captcha":"-mEZQK8bd4DN-FCd_FEQA","spinner":"_1Zi29LBpAFvSr7fc2u1OPc","sentTitle":"_1zU0-458k0BF7fZvQHLr5G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerification/PhoneVerificationForm.scss
// module id = 460
// module chunks = 0